module.exports = __webpack_public_path__ + "img/features-03-image-03.39face9a.png";